import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as Global from 'src/app/global';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.scss'],
})
export class OtpVerificationComponent implements OnInit {
  Global = Global;
  otpForm: FormGroup;

  @Input() verificationType: string = 'registration';
  @Input() queryParams: string = 'coach';
  @Input() emailToVerify: string = '';
  @Output() onVerificationAction: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private authService: AuthService
  ) {
    this.otpForm = formBuilder.group({
      email: [null, Validators.compose([])],
      otp_code: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.minLength(6),
          Validators.maxLength(6),
        ]),
      ],
    });
  }

  ngOnInit(): void {}

  submitOtp(event: any) {
    this.otpForm.markAllAsTouched();
    setTimeout(() => {
      Global.scrollToQuery('.form-control.is-invalid');
    }, 100);

    if (this.otpForm.valid) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;

      this.authService
        .verifyOtp({
          email: this.emailToVerify,
          otp: this.otpForm.value.otp_code,
          type: this.verificationType,
          for: this.queryParams??'coach',
        })
        .subscribe(
          async (res) => {
            const data = res.data;
            if (res.status == 'success') {
              // this.toastr.success(res.message);
              this.onVerificationAction.emit(true);
            } else if (res.status == 'val_error') {
              this.toastr.error(Global.getValidationMessage(res.errors ?? []));
            } else {
              this.toastr.error(res.message);
            }

            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
          },
          (err) => {
            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
            this.toastr.error(Global.getServerErrorMessage(err));
          }
        );
    }
  }

  resendOtp(event: any) {
    event.target.classList.add('btn-loading');
    event.target.disabled = true;

    this.authService
      .coachResendVerifyOtp({
        email: this.emailToVerify,
        otp: this.otpForm.value.otp_code,
        for: this.queryParams??'coach',
      })
      .subscribe(
        async (res) => {
          const data = res.data;
          if (res.status == 'success') {
            this.toastr.success(res.message);
            Global.disableButtonForTimeFrame(120, 'resendotp-button');
          } else if (res.status == 'val_error') {
            this.toastr.error(Global.getValidationMessage(res.errors ?? []));
          } else {
            this.toastr.error(res.message);
          }

          event.target.classList.remove('btn-loading');
          event.target.disabled = false;
        },
        (err) => {
          event.target.classList.remove('btn-loading');
          event.target.disabled = false;
          this.toastr.error(Global.getServerErrorMessage(err));
        }
      );
  }
}
